"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var enableInboxRuleRequest_1 = require("owa-service/lib/factory/enableInboxRuleRequest");
var enableInboxRuleOperation_1 = require("owa-service/lib/operation/enableInboxRuleOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
/**
 * Helper method that creates the EnableInboxRuleRequest body
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleRequest
 */
function createRequestBody(inboxRule) {
    return enableInboxRuleRequest_1.default({ Header: ServiceRequestUtils_1.getJsonRequestHeader(), Identity: inboxRule.Identity });
}
/**
 * Enable inbox rule service
 * @param inboxRule the inbox rule
 * @return EnableInboxRuleResponse
 */
function enableInboxRuleService(inboxRule) {
    var requestBody = createRequestBody(inboxRule);
    return enableInboxRuleOperation_1.default(requestBody);
}
exports.default = enableInboxRuleService;
//# sourceMappingURL=enableInboxRuleService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/services/enableInboxRuleService.js
// module id = 5169
// module chunks = 2